export const ctaStyling = "c1d4t95n";
export const ctaExtraMarginBottom = "cli1s2u";
export const ctaText = "c13i83b1";
export const ctaDescription = "c1evlaqc";
export const ctaButton = "ckq0v05";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");